import { Form, Input, Select, Switch } from "antd";
import { useModal } from "../../../customHooks/useModal";
import InputFormContainer from "../../Atoms/InputFormContainer/InputFormContainer";
import Button from '../../Atoms/Button/Button';
import Modal from '../../Organisms/Modal/Modal';
import iconSuccess from '../../../assets/icon-check-success.svg'
import iconWarning from '../../../assets/warning.svg'
import { useLocation } from "wouter";
import './FormCategory.scss'
import { useState } from "react";
const Option = Select

const FormCategory = ({ isEditCategory }) => {
  const [checkedStatus, setCheckedStatus] = useState(true)
  const [isOpenModal, openModal, closeModal] = useModal()
  const [isOpenModalStatus, openModalStatus, closeModalStatus] = useModal(false)
  const [isOpenModalDelete, openModalDelete, closeModalDelete] = useModal(false)
  const [, setLocation ] = useLocation();
  const [form] = Form.useForm();

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
    openModal(true) // Si se envia el formulario correctamente, se muestra el modal
  };

   // Limpiar formulario
   const clearForm = () => {
    form.resetFields()
    closeModal()
  }

  // Abre el modal para confirmar cambio de categoria
  const openModalChangeStatusCategory = (value) => {
    openModalStatus()
  }

  // Cambiar status de categoria
  const changeStatusOfCategory = () => {
    setCheckedStatus(prevStatus => !prevStatus)
    closeModalStatus()
  }

  // Eliminar categoria
  const deleteCategory = () => {
    closeModalDelete()
    setLocation('/productos/categorias/gestionar')
  }
      
  return (
    <>
      <Form onFinish={sendForm}  form={form} initialValues={{
        name_category: isEditCategory ? 'Nombre de la categoría' : null,
        category: isEditCategory ? 'telecom' : null,
      }}>
        <div className="nd-grid m-grid-2">
          <InputFormContainer label="Nombre de la categoría:" indentificador="name_category">
            <Form.Item name="name_category" rules={[{required: true, message: "Por favor ingresa el nombre de la Categoría"}]}>
              <Input size="large" placeholder="Coloque un nombre" />
            </Form.Item>
          </InputFormContainer>
            
          <InputFormContainer label="Categoría a la que pertenece:" indentificador="category">
            <Form.Item name="category" rules={[{ required: true, message: "Categoria" }]}>
              <Select placeholder="Categoria" size="large">
                <Option value={"telecom"}>Telecom</Option>
              </Select>
            </Form.Item>
          </InputFormContainer>
        </div>

        { 
          isEditCategory &&
          <div className="">
            <span className="mr-15">Categoría activa</span> <Switch checked={checkedStatus} defaultChecked onChange={value => openModalChangeStatusCategory(value)} />
          </div>
        }

        <div className="buttons-container m-cols-2 mt-30">
          {
            isEditCategory 
            ?
            <div className="associate-profile-header_buttons m-cols-2 mt-20">
              <div className="header-buttons_one">
                <span className="button grayColor s-large m-auto" onClick={() => openModalDelete()}>Eliminar categoría</span>
              </div>
              <div className="header-buttons_two">
                <span className="button primary outline s-large m-auto">Cancelar</span>
                <Button content="Guardar cambio" customClass="s-large m-auto" type="primary" htmlType="submit" />
              </div>
            </div>
            :
            <>
              <span className="button primary outline s-large m-auto">Cancelar</span>
              <Button content="Crear categoría" customClass="s-large m-auto" type="primary" htmlType="submit" />
            </>
          }
          
        </div>

      </Form>
        
      {/* Modal editar/crear */}
      <Modal
        isOpenModal={isOpenModal}
        closeModal={closeModal}
        iconModal={iconSuccess}
        titleModal="¡Listo!" 
        subTitleModal={` ${isEditCategory ? 'Categoría editada correctamente' : 'Has creado una categoría correctamente ¿Qué quieres hacer ahora?'}
        `}
      >
        <div className="buttons-container center">
          {
            !isEditCategory ?
          <>
            <Button content="Crear otro categoría" customClass="s-large m-auto" type="primary" clickHandler={() => clearForm()} />
            <Button content="Gestionar las categorías" customClass="s-large m-auto" type="primary outline" clickHandler={() => setLocation('/productos/categorias/gestionar')}/>   
          </>
          :
          <Button content="Gestionar las categorías" customClass="s-large m-auto" type="primary outline" clickHandler={() => setLocation('/productos/categorias/gestionar')}/>   
          }
        </div>
      </Modal>
      
      {/* Modal Cambiar status */}
      <Modal
        isOpenModal={isOpenModalStatus}
        closeModal={closeModalStatus}
        iconModal={iconWarning}
        titleModal="Cuidado" 
        subTitleModal={`Estas a punto de ${checkedStatus ? 'inactivar' : 'activar'} una categoría, ¿confirmas esta acción?`}
      >
        <div className="buttons-container center">
          <Button content={`Si, ponerla ${checkedStatus ? 'inactiva' : 'activa'}`} customClass="s-large m-auto" type="primary" clickHandler={() => changeStatusOfCategory()} />
          <Button content="Cancelar" customClass="s-large m-auto" type="primary outline" clickHandler={() => closeModalStatus()}/>   
        </div>
      </Modal>

      {/* Modal eliminar categoria */}
      <Modal
        isOpenModal={isOpenModalDelete}
        closeModal={closeModalDelete}
        iconModal={iconWarning}
        titleModal="Cuidado" 
        subTitleModal="Estas a punto de eliminar una categoría, ¿confirmas esta acción?"
      >
        <div className="buttons-container center">
          <Button content="Si, eliminar " customClass="s-large m-auto" type="primary" clickHandler={() => deleteCategory()} />
          <Button content="Cancelar" customClass="s-large m-auto" type="primary outline" clickHandler={() => closeModalDelete()}/>   
        </div>
      </Modal>
    </>
  )
}

export default FormCategory
